import Gradient from '../../lib/stripe-gradient/Gradient';

export function gradient(page) {
	/*--------------------------------
	グラデーション
	--------------------------------*/
	const gradient01 = new Gradient({
		canvas: '#canvas01',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});

	const gradient02 = new Gradient({
		canvas: '#canvas02',
		colors: ['#ff8467', '#5f51bc', '#ff8467', '#5f51bc'],
	});


	setTimeout(showSplah01, 600);
	setTimeout(showSplah02, 800);

	setTimeout(showCopy, 1700);
	setTimeout(showDesp, 2100);

	setTimeout(showSplah03, 2600);

	let splash01 = document.getElementById("mask01");
	let splash02 = document.getElementById("mask02");
	let splash03 = document.getElementById("mask03");
	//console.log(splash01);

	let copy = document.querySelector(".aboutVisual .overArea .ttl");
	let desp1 = document.querySelector(".aboutVisual .overArea .despPc");
	let desp2 = document.querySelector(".aboutVisual .overArea .despSp");
	//console.log(copy);

	function showSplah01() {
		splash01.classList.add("active");
	}
	function showSplah02() {
		splash02.classList.add("active");
	}
	function showSplah03() {
		splash03.classList.add("active");
	}

	function showCopy() {
		copy.classList.add("active");
	}
	function showDesp() {
		desp1.classList.add("active");
		desp2.classList.add("active");
	}

}


